import { on } from '@lucid/core';

/**
 * "Mehr Waschungen / Passt dazu": switches the two panels from the segmented control. The inactive panel stays in
 * the layout box (invisible and inert) so the lazy recommendations element can still see the viewport and load.
 * When the recommendations come back empty, the switch and their panel are removed.
 */
class LucidProductRecs extends HTMLElement {
  #off = null;
  #observer = null;

  connectedCallback() {
    this.#off = on('segmented:change', (event) => {
      if (event.detail?.name !== this.dataset.group) return;
      this.#show(event.detail.value === 'recs' ? 'recs' : 'siblings');
    });
    const async = this.querySelector('product-recommendations');
    if (async) {
      this.#observer = new MutationObserver(() => this.#checkAsync(async));
      this.#observer.observe(async, { attributes: true, childList: true });
      this.#checkAsync(async);
    }
  }

  disconnectedCallback() {
    this.#off?.();
    this.#observer?.disconnect();
  }

  #show(name) {
    this.querySelectorAll('[data-panel]').forEach((panel) => {
      const active = panel.getAttribute('data-panel') === name;
      panel.classList.toggle('is-inactive', !active);
      panel.inert = !active;
      panel.classList.toggle('is-entering', active);
      if (active) {
        panel.querySelectorAll('.lucid-recs__item').forEach((item, index) => item.style.setProperty('--lc-i', String(index)));
      }
    });
  }

  #checkAsync(element, settled = false) {
    const failed = element.classList.contains('hidden') || element.hasAttribute('data-error');
    const loaded = element.dataset.recommendationsPerformed === 'true';
    const empty = loaded && !element.querySelector('.lucid-recs__item');
    if (!failed && !empty) return;
    if (empty && !failed && !settled) {
      window.setTimeout(() => this.#checkAsync(element, true), 600);
      return;
    }
    this.#observer?.disconnect();
    element.closest('[data-panel]')?.remove();
    this.querySelector('[data-lucid-segmented]')?.remove();
    const siblings = this.querySelector('[data-panel="siblings"]');
    if (!siblings) {
      const shell = this.closest('.lucid-section');
      if (shell instanceof HTMLElement) shell.hidden = true;
      return;
    }
    this.#show('siblings');
    const heading = this.querySelector('.lucid-recs__heading');
    const label = this.dataset.siblingsLabel;
    if (heading && label) heading.textContent = label;
  }
}

if (!customElements.get('lucid-product-recs')) customElements.define('lucid-product-recs', LucidProductRecs);
